export var FontFamilyBrands = {
  Caviar: 'Caviar-Market',
  DoorDash: 'DD-TTNorms'
};
export var typographyDefaultValues = {
  FontFamily: 'DD-TTNorms'
};